import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID, TransferState, makeStateKey } from "@angular/core";
import { timer } from "rxjs/internal/observable/timer";
import { CommonService } from "src/app/common/services";
import { MktTaggingTransformationService } from "src/app/core/services";
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');

@Injectable({
  providedIn: 'root'
})
export class TaggingService {
  private isBrowser: boolean;
  public taggingCardNameMap: any;
  selectedChks: any = [];
  productList: any = [];
  app_hierarchy: string;

  constructor(
    private _mktTagging: MktTaggingTransformationService,
    private _transferState: TransferState,
    private _commonService: CommonService,
    @Inject(PLATFORM_ID) private _platformId: string,
  ) {
    this.isBrowser = isPlatformBrowser(this._platformId);
    if (this.isBrowser) {
      this.selectedChks = this._commonService.getCookie('cmp_chk_section', true);
    }
  }

  initTaggingTransformationCc(pageName, taggingData, rocketFuelResponse, category, liveRampResponse) {
    if (!this.isBrowser) { return; }
    const test_ids = {
      'explore': '197_a_Cards_ExploreCardsMPP',
      'mpp': '197_c_Cards_Card_Category_MPP',
      'vac': '197_b_Cards_ViewAllCardsMPP'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const { products, pid } = this.getTaggingProductsData(this.productList, pageName);
    this.app_hierarchy = (tag[0].app_hierarchy || "").replace("CATEGORY_NAME", category);
    this._mktTagging.triggerPageTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], products, pid, app_hierarchy: this.app_hierarchy } });
    this.bannerDisplayed(pageName, taggingData, rocketFuelResponse, category, liveRampResponse);
  }

  private getTag(taggingName, taggingData) {
    const result = taggingData?.filter(item => item?.content_id === taggingName);
    return result;
  }

  private getTaggingProductsData(productList: any = [], pageName = '', section = '', taggingType = '') {
    const copyPidArr = [];
    let sectionTxt = ''
    const products = productList.map(obj => {
      if (!obj) return;
      const { PID, pidPT, section: secName } = obj || {};
      const priceObj = this._transferState.get(PRICE_DETAILS_KEY, []).filter(({ productIdentifier }) => productIdentifier == PID)[0];
      const productName = ((!priceObj?.hashCode) ? this.taggingCardNameMap[pidPT] : PID);
      copyPidArr.push(productName);
      if ('explore' === pageName) {
        sectionTxt = (section || secName)?.replaceAll(/\n/g, '')?.trim();
      }
      if (taggingType === 'compareNow') {
        section = this.selectedChks.filter(({ pid: chkPid }) => chkPid == PID)?.[0]?.section;
        if (pageName === 'explore') sectionTxt = section?.replaceAll(/\n/g, '')?.trim();
      }
      return ({
        category: 'cards:acquisition',
        product_name: 'c:' + productName,
        acquisition_source_code: priceObj?.hashCode || '',
      });
    });
    const pid = copyPidArr.toLocaleString();
    return ({ products, pid });
  }

  private getUniqueProducts = (productList) => {
    if (productList.length === 1) return productList;
    const uniquePids = new Set([]);
    let uniqueProducts = productList.filter(obj => {
      if (!uniquePids.has(obj.pidPT)) {
        uniquePids.add(obj.pidPT);
        return obj;
      }
      return false;
    });
    return uniqueProducts;
  }

  navCategory(pageName: any, taggingData: any, key: string, category) {
    if (pageName === "vac") return;
    const test_ids = {
      'explore': '197_a5_Cards_ExploreCardsMPP_NewCategorySelected',
      'mpp': '197_c5_Cards_CardCategoryMPP_NewCategorySelected',
    }
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const page_inter = key;
    const { products, pid } = this.getTaggingProductsData(this.productList, pageName);
    const app_hierarchy = this.app_hierarchy + ':new category selected';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], page_inter, products, pid, app_hierarchy } });
  }

  private bannerDisplayed(pageName, taggingData, rocketFuelResponse, category, liveRampResponse) {
    if (rocketFuelResponse.length == 0) return; // Not for page where banner is not enabled.
    const banner_array = rocketFuelResponse.map(({ bannerContent, rocketFuelbannerContent }) => this.getBannerArray(bannerContent, rocketFuelbannerContent));
    // const pid = bannerContent.pid;
    const test_ids = {
      'explore': '197_a2_Cards_ExploreCardsMPP_BannerDisplayed',
      'mpp': '197_c2_Cards_CardCategoryMPP_BannerDisplayed',
      'vac': '197_b2_Cards_ViewAllCardsMPP_BannerDisplayed'
    }
    const testID = test_ids[pageName];
    const tag = { ...this.getTag(testID, taggingData)[0], ...liveRampResponse };
    delete tag.content_id;
    const form_type = !liveRampResponse?.acxiom_response ? 'Static Banner' : 'Personalized Banner';
    const instance = setTimeout(_ => { clearTimeout(instance); this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag, form_type, banner_array, products:[] } }); }, 2000);
  }

  bannerClicked(offername: string, taggingData: any, bannerContent, category, pageName, rocketFuelbannerContent, liveRampResponse) {
    const banner_array = this.getBannerArray(bannerContent, rocketFuelbannerContent);
    const pid = bannerContent.pid;
    const test_ids = {
      'explore': '197_a4_Cards_ExploreCardsMPP_BannerClicked',
      'mpp': '197_c4_Cards_CardCategoryMPP_BannerClicked',
      'vac': '197_b4_Cards_ViewAllCardsMPP_BannerClicked'
    }
    const testID = test_ids[pageName];
    const tag = { ...this.getTag(testID, taggingData)[0], ...liveRampResponse };
    delete tag.content_id;
    const form_type = !liveRampResponse?.acxiom_response ? 'Static Banner' : 'Personalized Banner';
    const app_hierarchy = this.app_hierarchy + ':banner clicked'; // TODO: MPP Category banner based logic update.
    const banner_click_attribution = `${app_hierarchy}~${form_type}~${banner_array.category}~${banner_array.product_name}~${banner_array.acquisition_source_code}~${banner_array.cms_contentID}~${banner_array.scenarioID}~${banner_array.banner_layout}~${banner_array.positionID}~${banner_array.banner_cta}}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag, form_type, link_name: offername, banner_click_attribution, pid: (pid || offername), banner_array, products:[]} });
  }

  private getBannerArray(bannerContent, rocketFuelbannerContent) {
    return {
      "category": `${(!rocketFuelbannerContent?.clickURL) ? 'cards static' : 'cards'}:offers`,
      "product_name": "c:" + rocketFuelbannerContent?.pid || '',
      "acquisition_source_code": rocketFuelbannerContent?.hashCode || '',
      "promo_code": rocketFuelbannerContent?.promoCode || '',
      "cms_contentID": rocketFuelbannerContent?.contentID || '',
      "scenarioID": rocketFuelbannerContent?.scenarioID || '',
      "contentID": rocketFuelbannerContent?.contentID || '',
      "banner_creative": rocketFuelbannerContent?.creativename || '',
      "positionID": rocketFuelbannerContent?.positionID || '',
      "banner_layout": rocketFuelbannerContent?.moduletype || '',
      "banner_title": bannerContent?.banner_title?.replaceAll(/\n/g, ""),
      "banner_description": bannerContent?.banner_description?.replaceAll(/\n/g, ""),
      "banner_cta": bannerContent?.banner_cta
    };
  }

  tdsHeaderLinkClick(pageName: any, taggingData: any, key: string, section = '', category: any) {
    const { products, pid } = this.getTaggingProductsData(this.productList, pageName, section);
    const test_ids = {
      'explore': '197_a6_Cards_ExploreCardsMPP_PageLinkClicked',
      'mpp': '197_c6_Cards_CardCategoryMPP_PageLinkClicked',
      'vac': '197_b6_Cards_ViewAllCardsMPP_PageLinkClicked'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const page_inter = key;
    const app_hierarchy = this.app_hierarchy + ':page link clicked';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], page_inter, products, pid, app_hierarchy } });
  }

  public filterChipsSelected(productList, page_inter, taggingData) {
    if (page_inter == '') return;
    const { products, pid } = this.getTaggingProductsData(productList);
    const testID = '197_b5_Cards_ViewAllCardsMPP_New_Filter_Selected';
    const tag = this.getTag(testID, taggingData);
    const app_hierarchy = this.app_hierarchy + ':new filter selected';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag?.[0], app_hierarchy, page_inter, products, pid } });
  }

  compareNowBtnClicked(pageName, taggingData, productList, category, page_inter = 'Compare Now', section = '') {
    const pList = this.getUniqueProducts(productList);
    let { products, pid } = this.getTaggingProductsData(pList, pageName, section, 'compareNow');
    const event = 'page_interaction';
    const test_ids = {
      'explore': '197_a9_Cards_ExploreCardsMPP_CompareNow',
      'mpp': '197_c9_Cards_CardCategoryMPP_CompareNow',
      'vac': '197_b9_Cards_ViewAllCardsMPP_CompareNow'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const app_hierarchy = this.app_hierarchy + ':compare now';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], page_inter, event, pid, products, app_hierarchy } });
  }

  compareCheckBoxClicked(pageName, taggingData, productList, section, category, text = 'Compare Checkbox Selected') {
    const { products, pid } = this.getTaggingProductsData(productList, pageName, section);
    const singlePid = pid.split(",")[0];
    const uniqueProducts = [products[0]];
    const cardName = this.taggingCardNameMap[singlePid];
    this.selectedChks.push({ pid: singlePid, section: section }); // for Compare now button
    if (this.selectedChks.length > 3) this.selectedChks.shift();
    this._commonService.updateCookie('cmp_chk_section', JSON.stringify(this.selectedChks));
    let page_inter = this.getPageInter(pageName, cardName, section, text);
    const event = 'page_interaction';
    const test_ids = {
      'explore': '197_a8_Cards_ExploreCardsMPP_CompareCheckboxSelected',
      'mpp': '197_c8_Cards_CardCategoryMPP_CompareCheckBoxSelected',
      'vac': '197_b8_Cards_ViewAllCardsMPP_CompareCheckboxSelected'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const app_hierarchy = this.app_hierarchy + ':compare checkbox selected';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], page_inter, event, pid: singlePid, products: uniqueProducts, app_hierarchy } });
  }

  getPageInter(pageName, cardName, section = '', text = '') {
    if (pageName === 'vac' || pageName === 'mpp') section = '';
    const sectionTxt = section?.replace(/\n/g, '')?.trim();
    const cardTxt = (cardName ? cardName + '|' + text : text).replace(`:${sectionTxt}`, '');
    let page_inter = (sectionTxt ? sectionTxt + '|' + cardTxt : cardTxt);
    return page_inter;
  }

  additionalInfoClicked(pageName, taggingData, productList, category) {
    const { pid } = this.getTaggingProductsData(productList, pageName);
    let singlePid = pid.split(",")[0];
    const test_ids = {
      'explore': '197_a11_Cards_ExploreCardsMPP_Additional_Information',
      'mpp': '197_c10_Cards_CardCategoryMPP_Additional_Information',
      'vac': '197_b11_Cards_ViewAllCardsMPP_Additional_Information'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const app_hierarchy = this.app_hierarchy + ':additional information';
    return this._mktTagging.triggerPageTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], pid: singlePid, app_hierarchy } });
  }

  pageLinkClickTagging(pageName, taggingData, productList, text, isApplyNow = false, category, section = '') {
    const { products, pid } = this.getTaggingProductsData(productList, pageName, section);
    let singlePid = pid.split(",")[0];
    const uniqueProducts = [products[0]];
    let cardName = this.taggingCardNameMap[singlePid];
    if (!cardName && isNaN(Number(singlePid))) cardName = singlePid;
    text = (text || '').replace(/ \+$/, '');
    let page_inter = this.getPageInter(pageName, cardName, section, text);
    const event = (isApplyNow) ? 'page_interaction|click_to_apply' : 'page_interaction';
    const test_ids = {
      'explore': '197_a7_Cards_ExploreCardsMPP_CardTileLinkClicked',
      'mpp': '197_c7_Cards_CardCategoryMPP_CardTileLinkClicked',
      'vac': '197_b7_Cards_ViewAllCardsMPP_CardTileLinkClicked'
    };
    const testID = test_ids[pageName];
    const tag = this.getTag(testID, taggingData);
    const app_hierarchy = this.app_hierarchy + ':card tile link clicked';
    return this._mktTagging.triggerEventTagging('nonicms_content', testID, { dynamicContent: { ...tag[0], page_inter, event, pid: singlePid, products: uniqueProducts, app_hierarchy } });
  }
}    